<template>
  <v-card elevation="0" :disabled="!isEditMode">
    <v-card-text>
      <v-container grid-list-md v-if="attestation">
        <!-- voie privilgiee skills -->
        <v-form ref="form">
          <v-row>
            <v-col md="4">
              <v-menu
                :disabled="!isEditMode"
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                :return-value.sync="attestation.date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="attestation.date"
                    label="* Date:"
                    prepend-icon="mdi-calendar"
                    readonly
                    :rules="[() => !!attestation.date || 'Champ obligatoire']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="fr-CH"
                  first-day-of-week="1"
                  v-model="attestation.date"
                  @input="$refs.menu1.save(attestation.date)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-select
                clearable
                :readonly="!isEditMode"
                :label="descriptions.objective_achieved"
                :items="['atteints', 'partiellement atteints', 'non atteints']"
                v-model="attestation.objective_achieved"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                clearable
                :readonly="!isEditMode"
                :label="descriptions.next_level"
                :items="nextLevelVariants"
                v-model="attestation.next_level"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                :readonly="!isEditMode"
                outlined
                :label="descriptions.comment"
                v-model="attestation.comment"
                counter
                maxlength="1500"
              ></v-textarea>
            </v-col>
            <!-- competence transversales -->
            <v-col cols="12">
              <h3>Compétences transversales</h3>
            </v-col>
            <v-col cols="12" md="3" md3>
              <v-select
                clearable
                :readonly="!isEditMode"
                :label="descriptions.work_organisation"
                :items="excellentOrNot()"
                v-model="attestation.work_organisation"
              ></v-select>
            </v-col>
            <v-col cols="12" md="3" md3>
              <v-select
                clearable
                :readonly="!isEditMode"
                :label="descriptions.group_integration"
                :items="excellentOrNot()"
                v-model="attestation.group_integration"
              ></v-select>
            </v-col>
            <v-col cols="12" md="3" md3>
              <v-select
                clearable
                :readonly="!isEditMode"
                :label="descriptions.motivation"
                :items="excellentOrNot()"
                v-model="attestation.motivation"
              ></v-select>
            </v-col>
            <v-col cols="12" md="3" md3>
              <v-select
                clearable
                :readonly="!isEditMode"
                :label="descriptions.home_study"
                :items="excellentOrNot(false)"
                v-model="attestation.home_study"
              ></v-select>
            </v-col>
          </v-row>
          <attestation-job-form :attestation="attestation" v-if="attestation.isJobCourse" :readonly="!isEditMode" />
        </v-form>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
// models
import Description from "@/models/Description"
// components
import AttestationJobForm from "@/components/attestations/AttestationJobForm.vue"
// utils
import { getCourseVariants } from "@/utils/helpers"

export default {
  components: {
    AttestationJobForm,
  },
  props: {
    attestation: {
      required: true,
    },
    isEditMode: {
      required: true,
    },
  },
  data() {
    return {
      form: false,
      menu1: false,
    }
  },
  watch: {
    isEditMode: {
      // if attestation date is not defined and in edit mode then set it to today
      immediate: true,
      handler(newValue) {
        if (newValue && !this.attestation.date) {
          this.attestation.date = new Date().toISOString().substr(0, 10)
        }
      },
    },
  },
  computed: {
    descriptions() {
      return Description.every()
    },
    nextLevelVariants() {
      return getCourseVariants(this.attestation.course_type)
    },
  },
  methods: {
    excellentOrNot(feminine = true) {
      return feminine
        ? ["excellente", "bonne", "satisfaisante", "insatisfaisante"]
        : ["excellent", "bon", "satisfaisant", "insatisfaisant"]
    },
    validateForm() {
      return this.$refs.form.validate()
    },
  },
}
</script>
